module.exports = __webpack_public_path__ + "img/2.9442ba87.png";